module.exports = "/_next/static/images/5b4a5215ca45c72bee33be2bf1254697-mulher-com-cachos-maravilhosos-segurando-cartao-md@1x.jpg";